
import { Link } from 'react-router-dom';
import { CalculatorHero } from './components/CalculatorHero';
import { CalculatorPanel } from './components/CalculatorPanel';
import { CalculatorCTA } from './components/CalculatorCTA';

export default function RevenueCalculatorPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-5xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Back to Home
          </Link>
          <Link to="/" className="cursor-pointer">
            <img
              src="https://static.readdy.ai/image/55893c4a5915be14917a0a81b6ec721d/f5868736a4ed9c94ff4146ae0bef5b91.png"
              alt="Furnished Rental Management Canada Logo"
              className="h-14 w-auto"
            />
          </Link>
        </div>
      </header>

      <CalculatorHero />
      <CalculatorPanel />
      <CalculatorCTA
        formUrl="https://readdy.ai/api/form/d69u2e7mvg9ih2c7a75g"
      />

      {/* Footer */}
      <footer className="bg-[#505A5A] text-white py-8">
        <div className="max-w-5xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-300">
            &copy; 2025 Compliant Rental Management. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-sm text-gray-300 hover:text-white transition-colors"
          >
            Web Design
          </a>
        </div>
      </footer>
    </div>
  );
}
